module.exports = __webpack_public_path__ + "static/media/yaystack-icon-orange.20367ae9.png";


//////////////////
// WEBPACK FOOTER
// ./src/design/img/yaystack-icon-orange.png
// module id = 468
// module chunks = 0